import { useMsal } from "@azure/msal-react";
import React, { useEffect, useMemo, useState } from "react";
import { Trans } from "react-i18next";

import i18next from "../../../../assets/i18n/config";
import Button from "../../../../components/button/button";
import Icon from "../../../../components/icon";
import IconEnum from "../../../../components/icon/iconEnum";
import { UserMenu } from "../../../../containers/page/userMenu/userMenu";
import "../../../../containers/page/userMenu/userMenu.scss";
import { useAsync } from "../../../../hooks/useAsync";
import { SuspenseContainer } from "../../../../partnerCenter/src/containers/suspenseContainer";
import { DashboardPointInstancesResponse, PartnerOrganizationClient } from "../../../../services/partnerCenterService";
import { getAccountName } from "../../../../utils/account";
import AddTenantDialog from "../../components/dialogs/addTenantDialog";
import TenantList from "../../components/TenantList/TenantList";

import { APP_URLS } from "../../../../appUrls";
import OuterLink from "../../../../components/outerLink/outerLink";
import './homePage.scss';

const HomePage: React.FC = () => {
    const { accounts } = useMsal();
    const { data, executeAsync, isLoading, error } = useAsync<DashboardPointInstancesResponse>();
    const accountName = useMemo(() => accounts[0] && getAccountName(accounts[0]), [accounts])
    const [isAddTenantDialogOpen, setIsAddTenantDialogOpen] = useState<boolean>(false);

    const loadTenantInstances = () => {
        const partnerOrganizationClient = new PartnerOrganizationClient();
        executeAsync(() => partnerOrganizationClient.getDashboardPointInstances());
    }

    useEffect(() => {
        loadTenantInstances();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const openAddTenantDialog = () => {
        setIsAddTenantDialogOpen(true);
    }

    const closeAddTenantDialog = () => {
        setIsAddTenantDialogOpen(false);
    };

    return (
        <div className="home-page__container">
            <div className="home-page__header">
                <div className="home-page__header__left">
                    <div><Icon iconName={IconEnum.SyskitLogo} height={36} width={36} /></div>
                    <div className="home-page__header__left__links">
                        <p><OuterLink href={APP_URLS.faq} className="link">FAQ</OuterLink></p>
                        <p><OuterLink href={APP_URLS.startTrial} className="link">Start a Trial</OuterLink></p>
                        <p><OuterLink href={APP_URLS.partnerStackSignup} className="link">PartnerStack</OuterLink></p>
                        <p><OuterLink href={APP_URLS.subscriptionsPortal} className="link">Subscriptions Portal</OuterLink></p>
                    </div>
                </div>
                {accountName && <UserMenu accountName={accountName} />}
            </div>

            <div className="home-page__title-section">
                <h1 className="home-page__title">{i18next.t('partnerPortal.partnerPortal')}</h1>
                <p>{i18next.t('partnerPortal.clientSubInfo')}</p>
            </div>

            <div className="home-page__section">
                <div className="home-page__section__header">
                    <Button className="button" onClick={openAddTenantDialog}>{i18next.t('common:partnerPortal.addTenant')}</Button>
                </div>
                <div className="home-page__body">
                    <SuspenseContainer isLoading={isLoading} error={error} data={data} component={TenantList} />
                </div>
                <div className="home-page__footer">
                    <hr />
                    <p><Trans i18nKey="partnerPortal.needAssistance" components={{ mailLink: <a className="mail-link" href="mailto:partners@syskit.com" /> }}></Trans></p>
                </div>
            </div>

            <AddTenantDialog
                closeDialog={closeAddTenantDialog}
                isOpen={isAddTenantDialogOpen}
                onSuccess={loadTenantInstances}
            />
        </div >
    );
}

export default HomePage;